import PropTypes from 'prop-types';
import React from 'react';

import ResultSelector from './result_selector';

export function flexStyles() {
  return {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'center',
    alignContent: 'center',
  };
}

function getStyles(resultType) {
  switch (resultType) {
  case 'simple':
  case 'detailed':
  case 'bar':
    return {};
  default:
    return flexStyles();
  }
}

export default function Results(props) {
  let results;
  const {
    allResults,
    settings,
    // forAffiliate,
  } = props;
  const styles = getStyles(settings.resultType);
  const {
    resultRender,
  } = settings;

  if (allResults && allResults.length > 0) {
    results = allResults.map((result) => {
      if (resultRender) {
        return resultRender(result, settings);
      }

      return <ResultSelector key={result.lngProductId} result={result} settings={settings} />;
    });
  }
  return (
    <div className="snapgadget_results">
      <div style={styles}>
        {results}
      </div>
    </div>
  );
}

Results.propTypes = {
  allResults: PropTypes.arrayOf(PropTypes.shape({
    strProductName: PropTypes.string,
    strMerchantName: PropTypes.string,
    lngProductId: PropTypes.string,
    dblProductSalePrice: PropTypes.string,
  })).isRequired,
  settings: PropTypes.shape({
    resultRender: PropTypes.func,
    resultType: PropTypes.string,
  }).isRequired,
};
